/**
 * @generated SignedSource<<d4837320ad3d1e70acd89afe763d8875>>
 * @relayHash 26162da9421b897123835870aa889a88
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a3004a6a0ad1b804118c2ddd213ca62e54dddd52039fedc3d0b3477084c941b9

import type { ConcreteRequest } from 'relay-runtime';
export type AccessType = "EDIT" | "VIEW" | "%future added value";
export type RequestPageAccessInput = {
  accessType: AccessType;
  pageId: string;
};
export type RestrictedPageRequestPageAccessMutation$variables = {
  requestPageAccessInput: RequestPageAccessInput;
};
export type RestrictedPageRequestPageAccessMutation$data = {
  readonly requestPageAccess: {
    readonly displayName: string;
  } | null | undefined;
};
export type RestrictedPageRequestPageAccessMutation = {
  response: RestrictedPageRequestPageAccessMutation$data;
  variables: RestrictedPageRequestPageAccessMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "requestPageAccessInput"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "requestPageAccessInput",
        "variableName": "requestPageAccessInput"
      }
    ],
    "concreteType": "RequestPageAccessPayload",
    "kind": "LinkedField",
    "name": "requestPageAccess",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "displayName"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "RestrictedPageRequestPageAccessMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RestrictedPageRequestPageAccessMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "26162da9421b897123835870aa889a88",
    "id": "a3004a6a0ad1b804118c2ddd213ca62e54dddd52039fedc3d0b3477084c941b9",
    "metadata": {},
    "name": "RestrictedPageRequestPageAccessMutation",
    "operationKind": "mutation",
    "text": "mutation RestrictedPageRequestPageAccessMutation($requestPageAccessInput:RequestPageAccessInput!){requestPageAccess(requestPageAccessInput:$requestPageAccessInput){displayName}}"
  }
};
})();

(node as any).hash = "bfa35553df246be210070fea4313ce8c";

export default node;
